export default __webpack_public_path__ + "static/office2-3x-8627d9e4e261efb3192d9aefd77d1b77.jpg";